export const ApiUrl = {
  ACCOUNTS_ME: '/accounts/me',
  ALLOWED_APPLICATIONS: '/routes/ad/list_apps',
  STUDY_INFO: '/c_study?paths=c_name&paths=c_sponsor_name&paths=c_protocol_number',
}
